import { environment } from '@quartz-gov-legacy/environments/environment';
﻿
(function () {
    'use strict';

    angular
        .module('procedureModule')
        .factory('responsibilityService', service);

    service.$inject = ['$http'];

    function service($http) {
        var baseUrl = environment.apiUrl + '/Pilot/api/Responsibility';

        function returnData(response) {
            return response.data;
        }

        return {

            createResponsibility: function (responsibility) {
                return $http
                    .post(baseUrl, responsibility)
                    .then(returnData);
            },

            updateResponsibility: function (responsibility) {
                return $http
		            .put(
		                baseUrl + '/' + responsibility.ResponsibilityID,
                        responsibility)
		            .then(returnData);
            },

            deleteResponsibility: function (responsibilityId) {
                return $http
					.delete(baseUrl + '/' + responsibilityId)
					.then(returnData);
            },

            getResponsibility: function (responsibilityId) {
                return $http
					.get(baseUrl + '/' + responsibilityId)
					.then(returnData);
            },

            findResponsibilities: function (text, participantId) {
                return $http
                    .get(baseUrl + '/Search', {
                        params: {
                            searchTerm: text,
                            participantID: participantId
                        }
                    })
                    .then(returnData);
            }
        };
    }
})();
